module.exports = __webpack_public_path__ + "img/dink-kitchen-4.443a3bce.jpeg";